export default __webpack_public_path__ + "static/media/last moment.10e9b940.mp4";